<template>
  <div class="page page__list">
    <search-bar
      @search="onSearch"
      name="eq_name,eq_code"
      placeholder="请输入你需要搜索的设备"
      ref="searchBar"
    />
    <filter-bar @change="onSearch" :filters="filters" ref="filterBar" />
    <scroll-list @refresh="onSearch" @loadpage="onSearchNext">
      <router-link
        class="weui-cell weui-cell_access"
        v-for="item in items"
        :key="item.id"
        :to="'/oa/equipment/'+ item.eq_id"
      >
        <div class="weui-cell__bd">
          <p>{{item.eq_name}}</p>
          <!-- <p class="list-item-muted">{{item.eq_code}}</p> -->
        </div>
        <div class="weui-cell__ft">
          <p>{{item.eq_code}}</p>
          <span
            class="list-item-status"
            :class="{'warning':item.eq_audit_status!='已审核'}"
          >{{item.eq_audit_status}}</span>
        </div>
      </router-link>
    </scroll-list>
    <div class="list-footer">
      <label class="list-footer__label">合计：{{items.length}}台</label>
    </div>
    <add-button to="/oa/equipment_edit" />
  </div>
</template>

<script>
import SearchBar from "@/components/SearchBar.vue";
import FilterBar from "@/components/FilterBar.vue";
import ScrollList from "@/components/ScrollList.vue";
import AddButton from "@/components/button/Add.vue";
import list from "@/mixins/list.js";

export default {
  components: {
    SearchBar,
    FilterBar,
    ScrollList,
    AddButton
  },
  mixins: [list],
  data() {
    return {
      listUrl: "/api/oa/equipment/list",
      filters: [
       {
          type: "date",
          name: "createTime"
        },
        {
          type: "condition",
          label: "状态",
          value: -1,
          options: [
            {
              value: -1,
              label: "全部"
            },
            {
              value: 1,
              label: "待审核",
              condition: "eq_audit_status_code='UNAUDITED'"
            },
            {
              value: 2,
              label: "已审核",
              condition: "eq_audit_status_code='AUDITED'"
            }
          ]
        }
      ]
    };
  }
};
</script>